import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Box from '../components/Box.jsx';
import {Link} from 'react-router-dom';
import Test from './Test.jsx';
import BubblesRising from '../components/BubblesRising.jsx';




export default function Home() {
  return (
    <div className='page-content-home'>
      <div className='homepage-intro1'>
        <h3 className='d-flex flex-column justify-content-center align-items-center pt-3'>Soundboard</h3>
        <Container>
        <Row className="g-4 pt-4 justify-content-center">
          <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center align-items-center">
          <Link to="/soundboard-animal">
          <Box 
          title={'Animals'} 
          imageAlt={'Animals'} 
          imageStatic={'./images/livestock.png'} 
          imageGif={'./images/livestock.png'}
          audioVoice={'/audio/test.mp3'}/></Link>
          </Col>

          <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center align-items-center">
          <Link to="/soundboard-fruit">
          <Box 
          title={'Fruits'}
          imageAlt={'Fruits'} 
          imageStatic={'./images/fruit.png'} 
          imageGif={'./images/fruit.png'}
          audioVoice={'/audio/test.mp3'}/></Link>
          </Col>
        </Row>
        </Container>
      </div>
      
      <div className='homepage-intro2'>
        <h3 className='d-flex flex-column justify-content-center align-items-center pt-3'>Flipbook</h3>
        <Container>
          <Row className="g-4 pt-4 justify-content-center">
            <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center align-items-center">
            <Link to="/flipbook-dogs">
            <Box 
            title={'Dogs'} 
            imageAlt={'Dogs'} 
            imageStatic={'./images/dog-static.png'} 
            imageGif={'./images/dog-static.png'}
            audioVoice={'/audio/test.mp3'}/>
            </Link>
            </Col>

            <Col xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center align-items-center">
            <Link to="/flipbook-cats">
            <Box 
            title={'Cats'}
            imageAlt={'Cats'} 
            imageStatic={'./images/cat-static.png'} 
            imageGif={'./images/cat-static.png'}
            audioVoice={'/audio/test.mp3'}/>
            </Link>
            </Col>
          </Row>
      </Container>
      </div>
      
      <div className='homepage-intro3'>
        <BubblesRising />
      </div>
    </div>
  )
}